module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "logo-en.7480470f.svg" + "?" + Date.now();